export default {
  'menu.workbenchGroup': '工作臺',
  'menu.workbench': '工作臺',
  'menu.activitiesGroup': '活動中心',
  'menu.activities': '活動中心',
  'menu.activityDetail': '活動詳情',
  'menu.technicalNeeds': '技術需求',
  'menu.technicalNeeds.leads': '需求線索',
  'menu.technicalNeeds.demands': '技術需求',
  'menu.leads': '需求線索',
  'menu.leadDetail': '線索詳情',
  'menu.customers': '客戶與人脈',
  'menu.customers.organizations': '機構',
  'menu.customers.contacts': '聯絡人',
  'menu.relations': '客戶與人脈',
  'menu.relations.organizations': '機構',
  'menu.relations.contacts': '聯絡人',
  'menu.organizations': '機構',
  'menu.contacts': '聯絡人',
  'menu.organizationDetail': '機構詳情',
  'menu.contactDetail': '聯絡人詳情',
  'menu.demands': '技術需求',
  'menu.demandDetail': '技術需求詳情',
  'menu.technicalResources': '技術資源',
  'menu.technicalResources.experts': '專家資源',
  'menu.technicalResources.technologies': '技術成果',
  'menu.resources': '技術資源',
  'menu.resources.experts': '專家資源',
  'menu.resources.technologies': '技術成果',
  'menu.resources.suppliers': '機構管理',
  'menu.experts': '專家資源',
  'menu.technologies': '技術成果',
  'menu.businessConversion': '業務轉化',
  'menu.businessConversion.matchmaking': '供需對接',
  'menu.businessConversion.engagements': '正式對接',
  'menu.businessConversion.opportunities': '合作商機',
  'menu.businessConversion.conversionBusinesses': '轉化業務',
  'menu.matchmaking': '供需對接',
  'menu.engagements': '正式對接',
  'menu.expertDetail': '專家詳情',
  'menu.technologyDetail': '技術成果詳情',
  'menu.supplierDetail': '技術供應商詳情',
  'menu.opportunities': '合作商機',
  'menu.opportunityDetail': '商機詳情',
  'menu.businessAnalytics': '業務統計',
  'menu.businessDashboard': '業務統計',
  'menu.personalProfile': '個人檔案',
  'menu.personalSettings': '個人與設置',
  'menu.personalSettings.managerProfile': '個人檔案',
  'menu.personalSettings.businessSettings': '業務設置',
  'menu.personalSettings.modelSettings': '模型設定',
  'menu.personalSettings.dataManagement': '數據管理',
  'menu.personalSettings.permissions': '權限管理',
  'menu.managerProfile': '個人檔案',
  'menu.businessSettings': '業務設置',
  'menu.modelSettings': '模型設定',
  'menu.dataManagement': '數據管理',
  'menu.permissions': '權限管理',
  'menu.settings': '設置',
  'menu.settings.businessSettings': '業務設置',
  'menu.settings.modelSettings': '模型設定',
  'menu.settings.dataManagement': '數據管理',
  'menu.settings.mockData': '數據管理',
  'menu.globalSearch': '全局搜索',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.admin': '权限',
  'menu.admin.sub-page': '二级管理页',
  'menu.settings.permissions': '權限管理',
  'menu.login': '登錄',
  'menu.user.login': '登錄',
  'menu.user.accessDenied': '無權訪問',
  'menu.accessDenied': '無權訪問',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬信息）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬信息）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標淮列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.applications': '搜索列表（應用）',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.workbench': '返回工作臺',
  'menu.account.tenantManagement': '企業管理',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',
};
